<template>
  <div class="block_center">
    <!-- 行业应用模式下显示面包屑 -->
    <div class="breadcrumb" v-if="showBreadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{
          $t("menu.home")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="breadcrumb-link" @click="goToIndustry">{{
            $t("home.Industry")
          }}</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumbInfo.tabName">
          <span class="breadcrumb-link" @click="goToIndustryTab">{{
            breadcrumbInfo.tabName
          }}</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          breadcrumbInfo.productName
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 产品模式显示产品展示区 -->
    <div class="productShowcase" v-else>
      <!-- 顶部标签切换 -->
      <div class="showcaseTabs">
        <span
          v-for="tab in productTabs"
          :key="tab.id"
          :class="['tabItem', { active: currentTabIndex === tab.id }]"
          @click="switchProductTab(tab)"
        >
          {{ language === 'en' && tab.fullNameEn ? tab.fullNameEn : tab.fullName }}
        </span>
      </div>

      <!-- 产品卡片轮播 -->
      <div class="showcaseContent">
        <div class="carouselWrapper">
          <button class="navBtn prevBtn" @click="scrollProducts('prev')">
            <i class="el-icon-arrow-left"></i>
          </button>

          <div class="productCarousel" ref="productCarousel">
            <div
              v-for="product in productList"
              :key="product.id"
              :class="[
                'productCard',
                { active: currentproductIndex === product.id },
              ]"
              @click="goToProductDetail(product)"
            >
              <div class="cardInfo">
                <div class="cardImage">
                  <img :src="product.fileData" :alt="product.title" />
                </div>
                <h3 class="cardTitle">{{ product.title }}</h3>
                <p class="cardName">{{ product.familyCode }}</p>
                <div class="cardActions">
                  <button
                    class="downloadBtn"
                    :class="{ disabled: !canShowSubscribe(product) }"
                    :disabled="!canShowSubscribe(product)"
                    @click.stop="goToDownload(product)"
                  >
                    {{ $t("Buy.DownloadNow") }}
                  </button>
                  <button class="moreBtn" @click.stop="learnMore(product)">
                    {{ $t("Buy.learnMore") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <button class="navBtn nextBtn" @click="scrollProducts('next')">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Banner -->
    <div
      class="banner"
      ref="productIntroduction"
      :class="{ 'breadcrumb-banner': showBreadcrumb }"
      :style="bannerStyle"
    >
      <div class="bannerContent">
        <div class="bannerLeft">
          <h1 class="bannerTitle">{{ currentProduct?.title }}</h1>
          <h2 class="bannerSubtitle">{{ currentProduct?.familyCode }}</h2>
          <p class="bannerDesc" v-html="currentProduct?.content"></p>
        </div>
        <div class="bannerRight"></div>
      </div>
    </div>

    <!-- 顶部软件切换 -->
    <div class="softwareTabs" v-if="showRelProduct">
      <span class="tabLabel">相关软件：</span>
      <span
        v-for="(soft, idx) in relProductList"
        :key="idx"
        :class="['softwareItem', { active: currentSoftware === soft }]"
        @click="productFun(soft)"
      >
        {{ soft }}
      </span>
    </div>

    <div class="softwareTabs animate-on-scroll" v-else-if="showIndustryApp">
      <span class="tabLabel">相关解决方案：</span>
      <span
        v-for="soft in currentProduct?.industryApp"
        :key="soft.id"
        :class="['softwareItem', { active: currentSoftware === soft.id }]"
        @click="productFun(soft)"
      >
        {{ soft.industryAppName }}
      </span>
    </div>

    <div class="introduction animate-on-scroll" ref="myElement" id="introductionP">
      <ProjectSummitLab :menuList="menuList"></ProjectSummitLab>
    </div>
  </div>
</template>

<script>
import ProjectSummitLab from "./ProjectSummitLab.vue";
import {
  family,
  industryAppItem,
  Selector,
  getListByFamilyId,
  industryApplications,
} from "@/assets/API/AllProducts.js";

const baseUrl = require("@/utils/define.js").APIURl;

// 常量
const SCROLL_AMOUNT = 320;
const STICKY_OFFSET = 124;
const DEFAULT_TAB = { fullName: "全部", fullNameEn: "All", id: "all" };

export default {
  name: "AllProducts",

  components: {
    ProjectSummitLab,
  },

  data() {
    return {
      isSticky: false,
      stickyOffset: 0,
      baseUrl,
      menuList: [],
      currentTabIndex: "all",
      currentproductIndex: "",
      productTabs: [],
      productList: [],
      // 系列字典中启用/停用(不显示)的系列id集合，用于过滤「全部」标签下的产品
      visibleSeriesIds: new Set(),
      hiddenSeriesIds: new Set(),
      breadcrumbInfo: {},
      currentSoftware: "",
      currentProduct: {},
    };
  },

  computed: {
    language() {
      return this.$i18n.locale;
    },

    hasProductIdRoute() {
      return !!this.$route.query.productId;
    },

    showBreadcrumb() {
      // 仅行业应用跳转显示面包屑；productId 跳转保持产品展示区可见
      return !!this.$route.query.name;
    },

    bannerStyle() {
      return {
        backgroundImage: this.currentProduct?.introduceImg
          ? `url(${this.currentProduct.introduceImg})`
          : "none",
      };
    },

    relProductList() {
      return this.currentProduct?.relProduct?.split(",") || [];
    },

    showRelProduct() {
      return this.showBreadcrumb && this.currentProduct?.relProduct;
    },

    showIndustryApp() {
      return this.currentProduct?.industryApp?.length > 0;
    },
  },

  watch: {
    $route: {
      handler(newVal) {
        this.handleRouteChange(newVal);
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => this.observeSections());
  },

  beforeRouteLeave(to, from, next) {
    console.log("离开当前路由，执行清理");
    window.removeEventListener("scroll", this.handleScroll);
    this.$bus.$off("setBreadcrumbInfo");
    sessionStorage.removeItem("breadcrumbInfo");

    // 清理数据
    this.isSticky = false;
    this.stickyOffset = 0;
    this.menuList = [];
    this.currentTabIndex = "all";
    this.currentproductIndex = "";
    this.productTabs = [];
    this.productList = [];
    this.breadcrumbInfo = {};
    this.currentSoftware = "";
    this.currentProduct = {};

    next();
  },

  methods: {
    // ==================== 路由处理 ====================
    async handleRouteChange(route) {
      const cachedInfo = this.getCachedBreadcrumb();
      const routeProductId = route?.query?.productId;

      if (!route.query.name && !routeProductId) {
        this.currentProduct = cachedInfo;
        await this.getproductTabs();
        await this.getproductList();
      } else {
        this.breadcrumbInfo = {
          ...cachedInfo,
          productName: route.query.name || cachedInfo.productName,
        };
        console.log("面包屑信息:", this.breadcrumbInfo);

        this.currentProduct = cachedInfo;
        this.currentSoftware = this.relProductList[0] || "";

        // 通过 productId 进入时，先拉取产品列表后按 id 精确定位
        if (routeProductId) {
          await this.getproductTabs();
          await this.getproductList();
          const matchedProduct = this.findProductById(routeProductId);
          if (matchedProduct) {
            this.goToProductDetail(matchedProduct);
            this.$nextTick(() => this.scrollToIntroduction());
          }
        }
      }

      const currentProductId =
        this.currentProduct?.productId || this.currentProduct?.id;
      if (currentProductId) {
        this.getindustryAppItem(currentProductId);
      }
    },

    getCachedBreadcrumb() {
      try {
        return JSON.parse(sessionStorage.getItem("breadcrumbInfo")) || {};
      } catch {
        return {};
      }
    },

    // ==================== 数据获取 ====================
    async getproductTabs() {
      try {
        // 系列字典里停用(不显示)的系列不作为标签显示：enabledMark=true 只返回启用项，
        // 再与全量对比出停用系列id，供「全部」标签过滤其下产品
        const [enabledRes, allRes] = await Promise.all([
          Selector(true),
          Selector(false),
        ]);
        if (enabledRes.code === 200 && enabledRes.data?.list) {
          this.productTabs = [DEFAULT_TAB, ...enabledRes.data.list];
          this.visibleSeriesIds = new Set(
            enabledRes.data.list.map((item) => item.id)
          );
        }
        if (allRes.code === 200 && allRes.data?.list) {
          this.hiddenSeriesIds = new Set(
            allRes.data.list
              .map((item) => item.id)
              .filter((id) => !this.visibleSeriesIds.has(id))
          );
        }
      } catch (error) {
        console.error("获取产品标签失败:", error);
      }
    },

    async getproductList(id = null) {
      try {
        const res = await family({
          seriesId: id,
          enabledMark: false,
        });
        if (res.code === 200 && res.data?.length) {
          // 订阅显示关闭或所属系列已停用的产品不在本页显示
          this.productList = res.data
            .map(this.formatProduct)
            .filter((item) => this.isProductVisible(item));
          this.initCurrentProduct();
          if (this.$route.query.familyCode) {
            const matched = this.productList.find(
              (p) => p.familyCode === this.$route.query.familyCode
            );
            if (matched) {
              this.goToProductDetail(matched, false);
            }
          } else if (this.productList.length) {
            this.goToProductDetail(this.productList[0], false);
          }
        }
      } catch (error) {
        console.error("获取产品列表失败:", error);
      }
    },

    formatProduct(item) {
      const parseFileUrl = (json) => {
        try {
          const parsed = JSON.parse(json);
          return parsed?.[0]?.url ? this.baseUrl + parsed[0].url : "";
        } catch {
          return "";
        }
      };

      const showSubscribe = item?.showSubscribe;
      const isSubscribeVisible = ![
        false,
        "false",
        "FALSE",
        "N",
        "n",
        0,
        "0",
      ].includes(showSubscribe);

      return {
        ...item,
        title: this.language === "zh" ? item.title : item.titleEn,
        content: this.language === "zh" ? item.content : item.contentEn,
        showSubscribe: isSubscribeVisible ? "Y" : "N",
        icon: parseFileUrl(item.icon),
        fileData: parseFileUrl(item.fileData),
        bgImg: parseFileUrl(item.bgImg),
        introduceImg: parseFileUrl(item.introduceImg),
      };
    },

    initCurrentProduct() {
      const matched = this.currentProduct?.familyCode
        ? this.productList.find(
            (p) => p.familyCode === this.currentProduct.familyCode
          )
        : this.productList[0];

      if (matched) {
        this.goToProductDetail(matched, false);
      }
    },

    // 产品可见性：订阅显示关闭(showSubscribe 已在 formatProduct 归一化为 Y/N)
    // 或所属系列在系列字典中已停用的产品不显示；未关联系列的产品不受影响
    isProductVisible(item) {
      if (item?.showSubscribe === "N") return false;
      const seriesId = item?.seriesId;
      return !seriesId || !this.hiddenSeriesIds.has(seriesId);
    },

    findProductById(productId) {
      if (!productId) return null;
      const targetId = String(productId);
      return (
        this.productList.find(
          (item) =>
            String(item.id) === targetId || String(item.productId) === targetId
        ) || null
      );
    },

    async getindustryAppItem(id) {
      if (!id) return;

      try {
        const request = this.showBreadcrumb
          ? industryAppItem(id)
          : getListByFamilyId(id);
        const res = await request;

        if (res.code === 200 && res.data?.length) {
          this.menuList = res.data.map((item) => ({
            ...item,
            title: this.language === "zh" ? item.title : item.titleEn,
            content: this.language === "zh" ? item.content : item.contentEn,
          }));
        } else {
          this.menuList = [];
        }

        if (this.showBreadcrumb) {
          await this.loadIndustryApplications(id);
        }
      } catch (error) {
        console.error("获取行业应用详情失败:", error);
        this.menuList = [];
      }
    },

    async loadIndustryApplications(id) {
      try {
        const res = await industryApplications(id);
        if (res.code === 200 && res.data) {
          this.currentProduct = {
            ...res.data,
            introduceImg: this.parseFileData(res.data.fileData),
            title: this.language === "zh" ? res.data.title : res.data.titleEn,
            content:
              this.language === "zh" ? res.data.content : res.data.contentEn,
          };
          this.currentSoftware = this.relProductList[0] || "";
        }
      } catch (error) {
        console.error("获取行业应用失败:", error);
      }
    },

    parseFileData(fileData) {
      if (!fileData) return "";
      try {
        const parsed = JSON.parse(fileData);
        return parsed?.[0]?.url ? this.baseUrl + parsed[0].url : "";
      } catch {
        return "";
      }
    },

    // ==================== 交互处理 ====================
    switchProductTab(tab) {
      this.currentTabIndex = tab.id;
      this.getproductList(tab.id === "all" ? null : tab.id);
    },

    scrollProducts(direction) {
      const carousel = this.$refs.productCarousel;
      if (!carousel) return;

      carousel.scrollLeft +=
        direction === "prev" ? -SCROLL_AMOUNT : SCROLL_AMOUNT;
    },

    scrollActiveProductIntoView() {
      this.$nextTick(() => {
        const carousel = this.$refs.productCarousel;
        if (!carousel) return;

        const activeCard = carousel.querySelector(".productCard.active");
        if (!activeCard) return;

        const targetLeft =
          activeCard.offsetLeft - (carousel.clientWidth - activeCard.clientWidth) / 2;
        const maxLeft = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        const nextLeft = Math.min(Math.max(0, targetLeft), maxLeft);

        carousel.scrollTo({
          left: nextLeft,
          behavior: "smooth",
        });
      });
    },

    scrollToIntroduction() {
      const element = this.$refs.productIntroduction;
      if (!element) return;

      const fixedTopSelectors = [
        ".notice-image-wrap",
        ".notice-banner",
        ".summitek-header",
      ];
      const fixedTopBottom = fixedTopSelectors.reduce((bottom, selector) => {
        const fixedElement = document.querySelector(selector);
        if (!fixedElement) return bottom;

        const style = window.getComputedStyle(fixedElement);
        const rect = fixedElement.getBoundingClientRect();
        const visible = style.display !== "none"
          && style.visibility !== "hidden"
          && rect.height > 0;
        return visible ? Math.max(bottom, rect.bottom) : bottom;
      }, 0);
      const elementTop =
        element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: Math.max(0, elementTop - fixedTopBottom),
        behavior: "smooth",
      });
    },

    handleScroll() {
      const element = this.$refs.myElement;
      if (!element) return;

      const rect = element.getBoundingClientRect();
      this.stickyOffset = rect.top;
      this.isSticky = this.stickyOffset < STICKY_OFFSET;
    },

    // ==================== 页面跳转 ====================
    canShowSubscribe(product) {
      return product?.showSubscribe === "Y";
    },

    goToDownload(product) {
      if (!this.canShowSubscribe(product)) return;

      this.$router.push({
        path: "/Buy",
        query: {
          productId: product.id,
          familyCode: product.familyCode,
        },
      });
    },

    goToProductDetail(product, scroll = true) {
      console.log("当前产品:", product);
      this.currentproductIndex = product.id;
      this.currentProduct = product;
      this.initIndustryApp(product);
      this.getindustryAppItem(product.id);
      this.scrollActiveProductIntoView();
      if (!product.industryAppId) {
        this.currentSoftware = "";
        this.currentProduct.industryApp = null;
        // this.menuList = [];
      }
      // scroll=false 时（如首次进入页面默认选中）不滚动到介绍区
      if (scroll) {
        this.$nextTick(() => {
          this.scrollToIntroduction();
        });
      }
    },

    // 点击“了解更多”：切换到对应产品并滚动到产品介绍区
    learnMore(product) {
      this.goToProductDetail(product, true);
    },

    initIndustryApp(product) {
      const ids = product.industryAppId.split(",");
      const names =
        (this.language === "zh"
          ? product.industryAppName
          : product.industryAppNameEn
        )?.split(",") || [];

      const industryApp = ids.map((id, index) => ({
        id,
        industryAppName: names[index] || "",
      }));

      this.currentProduct.industryApp = industryApp;
      this.currentSoftware = industryApp[0]?.id || this.relProductList[0] || "";
    },

    goToIndustry() {
      this.$router.push({
        path: "/",
        query: { scrollTo: "productSys" },
      });
    },

    goToIndustryTab() {
      this.$router.push({
        path: "/",
        query: {
          scrollTo: "productSys",
          tabId: this.breadcrumbInfo.tabId,
        },
      });
    },

    observeSections() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      document.querySelectorAll('.animate-on-scroll').forEach((el) => {
        observer.observe(el);
      });
    },

    productFun(soft) {
      const isString = typeof soft === "string";

      const breadcrumbData = {
        familyCode: isString ? soft : soft.industryAppName,
        ...this.currentProduct,
        productId: isString ? this.currentProduct.productId : soft.id,
      };
      sessionStorage.setItem("breadcrumbInfo", JSON.stringify(breadcrumbData));

      this.$router.push({
        path: "/AllProducts",
        query: this.showBreadcrumb
          ? { familyCode: breadcrumbData.familyCode }
          : { name: soft.industryAppName },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.block_center {
  margin-top: 80px;
  .breadcrumb {
    background-color: #383838;
    display: flex;
    justify-content: center;
    .el-breadcrumb {
      width: 1300px;
      margin: 0 auto;
    }
    .breadcrumb-link {
      cursor: pointer;
    }
    :deep(.el-breadcrumb__item) {
      margin: 20px auto;
      color: rgba(255, 255, 255, 1);
      .el-breadcrumb__inner {
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
      }
    }
  }
  // 产品展示区样式
  .productShowcase {
    background: #f8f9fb;
    padding: 60px 0 80px;
    background: url("../../../assets/image/product_int_bg.png") no-repeat center top;
    background-size: 100% auto;

    .showcaseTabs {
      display: flex;
      justify-content: center;
      gap: 20px;
      margin-bottom: 50px;
      background-color: #f5f5f7;
      border-radius: 25px;
      width: fit-content;
      margin: 0 auto 50px;

      .tabItem {
        padding: 8px 15px;
        font-size: 16px;
        color: #666;
        cursor: pointer;
        border-radius: 25px;
        transition: all 0.3s;

        &:hover {
          color: #2a82e4;
        }

        &.active {
          background: #2a82e4;
          color: #fff;
        }
      }
    }

    .showcaseContent {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 60px;

      .carouselWrapper {
        position: relative;
        display: flex;
        align-items: center;

        .navBtn {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #a5a8ac;
          border: none;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;

          i {
            font-size: 18px;
            color: #fff;
          }

          &:hover {
            background: #2a82e4;

            i {
              color: #fff;
            }
          }

          &.prevBtn {
            margin-right: 12px;
          }

          &.nextBtn {
            margin-left: 12px;
          }
        }

        .productCarousel {
          flex: 1;
          min-width: 0;
          display: flex;
          gap: 30px;
          overflow-x: auto;
          scroll-behavior: smooth;
          padding: 20px 0;

          &::-webkit-scrollbar {
            display: none;
          }

          .productCard {
            flex-shrink: 0;
            width: 280px;
            background: #fff;
            border-radius: 6px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
            }
            &.active {
              transform: translateY(-8px);
              box-shadow: 0 12px 30px rgba(71, 72, 73, 0.25);
              // border: 2px solid #2a82e4;
            }

            .cardImage {
              height: 200px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
              }
            }

            .cardInfo {
              padding: 20px;
              color: #333;

              .cardTitle {
                font-size: 16px;
                font-weight: 600;
                margin: 0 0 8px;
                line-height: 1.4;
              }

              .cardName {
                font-size: 14px;
                margin: 0 0 20px;
              }

              .cardActions {
                display: flex;
                gap: 12px;

                .downloadBtn {
                  width: 38%;
                  padding: 6px 0;
                  font-size: 14px;
                  color: #fff;
                  background: #2a82e4;
                  border: none;
                  border-radius: 25px;
                  cursor: pointer;
                  transition: all 0.3s;

                  &:hover {
                    background: #1a6fc9;
                  }

                  &:disabled,
                  &.disabled {
                    background: #c0c4cc;
                    cursor: not-allowed;
                    color: #fff;
                  }
                }

                .moreBtn {
                  width: 38%;
                  padding: 6px 0;
                  font-size: 14px;
                  color: #666;
                  background: #f5f5f7;
                  border: none;
                  border-radius: 25px;
                  cursor: pointer;
                  transition: all 0.3s;

                  &:hover {
                    border-color: #2a82e4;
                    color: #2a82e4;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .banner {
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 621px;
    height: auto;
    display: flex;
    align-items: center;
    position: relative;

    // 添加渐变遮罩
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    // 行业应用详情模式：文字变白，加渐变遮罩
    &.breadcrumb-banner {
      &::before {
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0.65) 0%,
          rgba(0, 0, 0, 0.3) 60%,
          transparent 100%
        );
      }

      .bannerTitle,
      .bannerSubtitle {
        color: #fff;
      }

      .bannerDesc {
        color: #fff;
      }
    }

    .bannerContent {
      position: relative;
      z-index: 1;
      width: min(1500px, calc(100% - 64px));
      margin: 0 auto;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      gap: clamp(16px, 4vw, 80px);
      padding: 60px 0;

      .bannerLeft {
        flex: 0 1 760px;
        min-width: 0;
        max-width: min(760px, 100%);
        margin-right: auto;
        text-align: left;

        .bannerTitle {
          font-size: clamp(28px, 2.2vw, 36px);
          font-weight: 600;
          margin: 0 0 12px;
          line-height: 1.3;
          word-break: break-word;
        }

        .bannerSubtitle {
          font-size: clamp(18px, 1.6vw, 24px);
          font-weight: 500;
          margin: 0 0 24px;
          word-break: break-word;
        }

        .bannerDesc {
          font-size: clamp(12px, 0.8vw, 14px);
          line-height: 1.75;
          margin: 0;
          text-align: left;
          word-break: break-word;
          overflow-wrap: anywhere;

          :deep(*) {
            max-width: 100%;
            word-break: break-word;
            overflow-wrap: anywhere;
          }

          :deep(img),
          :deep(video) {
            height: auto;
            max-width: 100%;
          }

          :deep(table) {
            width: 100%;
            table-layout: fixed;
          }
        }
      }

      .bannerRight {
        flex: 0 1 200px;
        min-width: 0;
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .banner {
      min-height: 560px;
    }

    .banner .bannerContent {
      width: min(1500px, calc(100% - 48px));
      padding: 44px 0;
      gap: 18px;
    }

    .banner .bannerContent .bannerLeft {
      flex-basis: min(720px, 100%);
      max-width: min(720px, 100%);
    }

    .banner .bannerContent .bannerRight {
      flex-basis: 120px;
    }
  }

  @media screen and (max-width: 1024px) {
    .banner {
      min-height: 500px;
      align-items: flex-start;
    }

    .banner .bannerContent {
      width: min(1500px, calc(100% - 32px));
      padding: 36px 0;
    }

    .banner .bannerContent .bannerLeft {
      max-width: 100%;
    }

    .banner .bannerContent .bannerLeft .bannerDesc {
      text-align: left;
    }

    .banner .bannerContent .bannerRight {
      display: none;
    }
  }
  // 顶部软件切换
  .softwareTabs {
    padding: 40px 250px 20px;
    border-bottom: 1px solid #eee;

    .tabLabel {
      font-size: 14px;
      color: #666;
      margin-right: 15px;
    }

    .softwareItem {
      display: inline-block;
      padding: 6px 16px;
      margin-right: 10px;
      font-size: 14px;
      color: #333;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #2a82e4;
        color: #2a82e4;
      }

      &.active {
        background: #383838;
        border-color: #383838;
        color: #fff;
      }
    }
  }
}

/* ========== 滚动出现动画 ========== */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.animate-on-scroll.is-visible {
  opacity: 1;
  transform: translateY(0);
}
</style>
